import {useState} from 'react';
import clsx from 'clsx';

import BlogCard from './BlogCard.client';

export default function BlogPortal({categories, blogs}: any) {
  const [activeTag, setActiveTag] = useState<any>(false);

  //create array of blogs whose category array contains the active tag
  const filteredBlogs = activeTag
    ? blogs?.filter((blog: any) => {
        return blog?.category?.some((category: any) => {
          return category?.title === activeTag;
        });
      })
    : blogs;

  return (
    <div>
      {/* Desktop */}
      <div className="hidden flex-wrap items-center justify-center gap-x-[5px] gap-y-[10px] pt-12 md:flex">
        {categories?.map(({title}: any, i: number) => {
          const checkLength = blogs?.filter((blog: any) =>
            blog?.category?.some((category: any) => category?.title === title),
          ).length;
          return (
            checkLength > 0 && (
              <button
                key={i}
                onClick={() => {
                  activeTag === title
                    ? setActiveTag(false)
                    : setActiveTag(title);
                }}
                className={clsx([
                  activeTag === title ? 'btn-standard' : 'btn-standard-reverse',
                ])}
              >
                {title}
              </button>
            )
          );
        })}
      </div>
      {/* Mobile */}
      <div className="pt-6 md:hidden">
        <select
          className="btn-standard-reverse blog-select mx-auto border-0 border-dark-grey bg-light-beige !text-dark-grey focus:border-dark-grey focus:ring-0"
          onChange={(e) =>
            e?.target?.value === 'all'
              ? setActiveTag(false)
              : setActiveTag(e?.target?.value)
          }
        >
          <option value="all">All</option>
          {categories?.map(({title}: any, i: number) => {
            const checkLength = blogs?.filter((blog: any) =>
              blog?.category?.some(
                (category: any) => category?.title === title,
              ),
            ).length;
            return (
              checkLength > 0 && (
                <option key={i} value={title}>
                  {title}
                </option>
              )
            );
          })}
        </select>
      </div>
      <div className="grid grid-cols-1 gap-x-7 gap-y-12 py-space-m sm:grid-cols-2 md:gap-y-25">
        {filteredBlogs?.length > 0 ? (
          filteredBlogs?.map((blog: any, i: number) => (
            <BlogCard key={i} {...blog} />
          ))
        ) : (
          <h4 className="blockH4 col-span-3 w-full font-bold text-orange">
            No Results
          </h4>
        )}
      </div>
    </div>
  );
}
